// event-bus.js
export class EventBus {
    constructor() {
        this.callbacks = {};
    }

    $on(event, callback) {
        if (!this.callbacks[event]) {
            this.callbacks[event] = [];
        }
        this.callbacks[event].push(callback);
    }

    $emit(event, ...args) {
        this.callbacks[event]?.forEach(callback => callback(...args));
    }

    $off(event, callback) {
        if (this.callbacks[event]) {
            this.callbacks[event] = this.callbacks[event].filter(cb => cb !== callback);
        }
    }
}

// 导出 EventBus 的实例
export const eventBus = new EventBus();